import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks/useOpenDeeplink';

/**
 * - 검색 보조(SearchHelper) 페이지로 이동, 키보드 자동 노출
 */
export const useMoveToSearch = () => {
  const { openDeeplink } = useOpenDeeplink();
  return useCallback(() => {
    openDeeplink('ably://search?show_keyboard=true');
  }, [openDeeplink]);
};
